/* External Imports */
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Configs */
import { ResearchShowsSt } from '@ieo/Common/CompLangConfig';

/* Styles */
/* Services */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';
import SingleImage from './SingleImage';
/**
 *
 * @param {Object} sectionContent
 * @param {string} region
 * @param {string} lang
 * @returns {ReactElement} component
 */
const DescriptionV5 = ({ sectionContent, lang }) => {
  return (
    <Box
      w={{ base: '100%', sm: '100', md: '100%' }}
      px={{ base: '16px', md: '30px', xl: '0px' }}
      pt={{ base: '55px', md: '90px', lg: '140px' }}
      pb={{ base: '60px', md: '40px', lg: '60px'  }}
      mx="auto"
    >
      <Box
        maxW={{
          base: '100%',
          xl: 1050,
          '2xl': '1036px',
        }}
        w="100%"
        mx="auto"
      >
        <Box
          display={'grid'}
          gridTemplateColumns={{
            base: '1fr',
            md: '1fr 1fr',
          }}
          gap={{ base: '0px', md: '24px', lg: '45px' }}
        >
          {searchByFieldId(sectionContent, 'ie-heading-v5') && (
            <Text
              fontFamily="FedraSansStd-medium"
              fontSize={{ base: '32px', md: '64px' }}
              color="#3B444B"
              display={{ base: 'block', md: 'none' }}
              lineHeight={{ base: '38px', md: '77px' }}
              mb={'23px'}
            >
              {searchByFieldId(sectionContent, 'ie-heading-v5').text}
            </Text>
          )}
          <Box pl={{ base: '0px', lg: '27px' }}>
            {searchByFieldId(sectionContent, 'ie-heading-v5') && (
              <Text
                lineHeight="77px"
                fontFamily="FedraSansStd-medium"
                fontSize={{ base: '32px', md: '64px' }}
                color="#3B444B"
                display={{ base: 'none', md: 'block' }}
                pb={'15px'}
              >
                {searchByFieldId(sectionContent, 'ie-heading-v5').text}
              </Text>
            )}

            <StructuredTextParser
              str={render(sectionContent[1]?.body)}
              fontFamily="FedraSansStd-book"
              className="innerEngineeringSecText"
              fontSize={{ base: '16px', md: '18px' }}
              lineHeight={{ base: '24px', xl: '30px' }}
              textAlign={lang === 'ar' ? 'right' : 'left'}
              mt={{ base: '10px', lg: '15px' }}
              color={{ base: '#323232', md: '#52483D' }}
              mb={{ base: '28px', md: '0px' }}
            />
          </Box>
          <Box display={{ base: 'flex' }} w={'100%'}>
            <SingleImage
              w="100%"
              h="100%"
              sectionContent={sectionContent[2]}
              px={'0px'}
              my={'0px'}
              maxH={'100%'}
            />
          </Box>
        </Box>
      </Box>
      <style global jsx>
        {`
          .innerEngineeringSecText p:last-child {
            padding-top: 30px;
          }
          .innerEngineeringSecText strong {
            color: #12166f;
            font-family: FedraSansStd-medium;
            font-weight: normal;
          }
        `}
      </style>
    </Box>
  );
};

export default DescriptionV5;
